import React, { useEffect } from 'react';
import { Redirect, Route } from 'react-router';
import { useSelector, useDispatch } from 'react-redux';
import { AuthLayout } from 'components/Layout';
import { checkLoggedStatus } from 'redux/actions/sign';

const AuthRoute = ({ children, ...props }) => {
    const { isLogged, _token } = useSelector((state) => state.sign);
    const dispatch = useDispatch();

    useEffect(() => {
        if (!_token) {
            dispatch(checkLoggedStatus());
        }
    }, [_token, dispatch]);

    return (
        <AuthLayout>
            <Route
                {...props}
                render={({ location }) => {
                    return isLogged ? (
                        children
                    ) : (
                            <Redirect
                                to={{
                                    pathname: '/login',
                                    state: { from: location },
                                }}
                            />
                        );
                }}
            // render={() => children}
            />
        </AuthLayout>
    );
};

export default AuthRoute;
